import { zodResolver } from '@hookform/resolvers/zod'
import { Grid } from '@mui/joy'
import { useForm } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { Button } from '~/shared/ui/Buttons'
import { DatePickerInput, FormProvider, TextInput } from '~/shared/ui/Form'
import { PlusIcon } from '~/shared/ui/Icons'
import { formSchema, FormValues } from '../EditForm/model'

type FormProps = {
  onSuccess: (formValues: FormValues) => void
  isSubmitting: boolean
}

export function Form({ onSuccess, isSubmitting }: FormProps) {
  const { t } = useTranslation()

  const form = useForm<FormValues>({
    resolver: zodResolver(formSchema),
  })

  return (
    <FormProvider form={form} onSuccess={onSuccess}>
      <Grid container spacing={2.5} sx={{ marginTop: '60px' }}>
        <Grid xs={12}>
          <TextInput
            label='form.number'
            name='number'
            placeholder='form.enter number'
            readOnly={isSubmitting}
          />
        </Grid>
        <Grid xs={6}>
          <DatePickerInput
            label='form.issue date'
            name='issuedDate'
            placeholder='form.enter issue date'
            readOnly={isSubmitting}
          />
        </Grid>
        <Grid xs={6}>
          <DatePickerInput
            label='form.valid until'
            name='expirationDate'
            placeholder='form.select date'
            readOnly={isSubmitting}
          />
        </Grid>
      </Grid>
      <br />
      <Button
        loading={isSubmitting}
        startDecorator={<PlusIcon />}
        fullWidth
        type='submit'
      >
        {t('button.add')}
      </Button>
    </FormProvider>
  )
}
